import {
    useCallback,
} from 'react'
import LaneFeesSpreadsheet from 'app/Apps/Pricing/LaneFees/LaneFeesSpreadsheet/LaneFeesSpreadsheet'
import {
    LaneFeesBulkItem,
} from 'app/Apps/Pricing/LaneFees/LaneFees.types'
import useFilter from 'app/hooks/useFilter/useFilter'
import LaneFeesRequests from 'app/requests/ContractBasis/LaneFees.requests'
import useSimpleApiRequest from 'app/hooks/useSimpleApiRequest'
import {
    AsyncMutationOptions,
} from 'app/types/request.types'

export default function LaneFeesBulkCreate({
    onClose,
}: Readonly<{ onClose: () => void }>) {
    const filterOptions = useFilter()

    const {
        mutateAsync: create,
    } = useSimpleApiRequest<{ items: LaneFeesBulkItem[] }>({
        title: 'New lane fees were created',
        name: 'LaneFeesBulkCreate',
        requestParams: LaneFeesRequests.bulkCreate(),
        onSuccess: () => {
            filterOptions.setDefaultData()
        },
    })

    const handleSave = useCallback(async (
        items: LaneFeesBulkItem[],
        options?: AsyncMutationOptions,
    ) => {
        await create({
            items,
        }, {
            ...options,
            onSuccess: options?.onSuccess || onClose,
        })
    }, [
        create,
        onClose,
    ])

    return (
        <LaneFeesSpreadsheet
            filterOptions={filterOptions}
            onSave={handleSave}
            onCancel={onClose}
        />
    )
}
